import { AppBar, Toolbar, Box, Typography, Stepper, Step, StepLabel } from "@material-ui/core";
import React, { useState } from "react";


// Styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import appbarStyles from "views/Styles/appbarStyles";
import { makeStyles } from "@material-ui/core/styles";
import { stepperStyles, QontoConnector } from "views/Styles/stepperStyles";

// Contexts
import NotificationContext from "views/Components/Context.js";
import { Auth } from "aws-amplify";
import { Description, Edit, ViewAgenda } from "@material-ui/icons";
import UploadSourceFile from "./UploadSourceFile";
import DataIngestionStep from "./DataIngestionStep";
import DataGenerationStep from "./DataGenerationStep";



const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stepperStyles(theme),
  ...appbarStyles(theme),
}));

const projectSteps = [
  {
    label: "Upload Resources",
    icon: <Description />,
    lockedMessage: "",
  },
  {
    label: "Data Ingestion",
    icon: <ViewAgenda />,
    lockedMessage: "Please upload at least one resource file to move on to the next step.",
  },
  {
    label: "Data Generation",
    icon: <Edit />,
    lockedMessage: "Please review the data ingestion to move on to the next step.",
  },
]

export default function DataGenerationPublisher() {

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [projectName, setProjectName] = useState("Data Project 1");
  const [visitedSteps, setVisitedSteps] = useState([0]);
  const { showNotification } = React.useContext(NotificationContext);
  const projectID = window.location.pathname.split("/").pop(); //extract it from the url



  const statusToStepMapping = {
    "Upload Resources": 0,
    "Data Ingestion": 1,
    "Data Generation": 2,
    default: 0,
  }

  const [projectCompletedTillStep, setProjectCompletedTillStep] = useState(0);

  // Handle step click
  const handleStepClick = (index) => {
    setActiveStep(index);
    // if (visitedSteps.includes(index)) {
    //   setActiveStep(index);
    // } else {
    //   const message = projectSteps[index].lockedMessage || "This step is locked.";
    //   showNotification(message, "danger");
    // }
  };

   const renderContent = () => {
      if (!projectSteps[activeStep]) {
        return <></>;
      }
      switch (projectSteps[activeStep].label) {
        case "Upload Resources":
          return (
            <UploadSourceFile
              projectID={projectID}
              setActiveStep={setActiveStep}
            />
          );
        case "Data Ingestion":
          return <DataIngestionStep projectID={projectID} setActiveStep={setActiveStep} />;
        case "Data Generation":
          return <DataGenerationStep projectID={projectID} setActiveStep={setActiveStep} />;
        default:
          return <></>;
      }
    };

  return (
    <Box>
      <AppBar position="static" className={classes.header}>
        <Toolbar>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            {/* Title */}
            <Typography
              variant="h5"
              style={{
                color: "black",
                fontWeight: "bold",
                flexShrink: 0,
                maxWidth: "45%",
                wordBreak: "break-word",
                overflow: "hidden",
                whiteSpace: "normal",
              }}
            >
              {projectName}
            </Typography>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              connector={<QontoConnector />}
              size="small"
              className={classes.stepperRoot}
              style={{ flexGrow: 1 }}
            >
              {projectSteps.map((step, index) => {
                const isDisabled = index > projectCompletedTillStep;
                return (
                  <Step key={step.label} onClick={() => handleStepClick(index)}>
                    <StepLabel
                      StepIconProps={
                        !isDisabled
                          ? {
                            classes: {
                              root: classes.stepIcon, // Default icon color
                              active: classes.activeStepIcon, // Active step circle
                              completed: classes.completedStepIcon, // Completed step color
                            },
                          }
                          : {} // If disabled, no classes applied
                      }
                    >
                      {step.label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        </Toolbar>
      </AppBar>
      <Box mt={3}>{renderContent()}</Box>
    </Box>
  );
}